var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',_vm._b({ref:"upload",attrs:{"data":_vm.data,"action":_vm.action,"headers":_vm.headers,"file-list":_vm.filelist,"on-preview":_vm.handlePreview,"before-remove":_vm.handleBeforeRemove,"on-exceed":_vm.handleExceed,"id":"myuploader"}},'el-upload',_vm.$attrs,false),[_vm._t("trigger"),_vm._t("tip")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }